import { EmployeeDocument } from '../Employees/queryBuilder';
import { EquipmentDocument } from '../Equipment/queryBuilder';
import { PanelDocument } from '../Panels/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  PanelLogDocument,
  panelLogPushQueryBuilder,
  panelLogsPullQueryBuilder,
} from './queryBuilder';

export function panelLogsFamilyMember(
  configBuilder: ConfigBuilder,
  employees: FamilyMember<EmployeeDocument>,
  equipment: FamilyMember<EquipmentDocument>,
  panels: FamilyMember<PanelDocument>,
): FamilyMember<PanelLogDocument> {
  const syncConfig = configBuilder<PanelLogDocument>(RxdbCollectionNameV2.PANEL_LOGS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, panelLogsPullQueryBuilder);
  push(syncConfig, panelLogPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.PANEL_LOGS, replicationState, [employees, equipment, panels]);
}
